<template>
    <div>
        <v-btn v-if="!search"
               outlined
               dense
               @click="search=!search"
               class="mb-5"
        >{{!code?'Select Code':code}}</v-btn>
        <v-text-field
                v-if="search"
                dense
                label="Search Code"
                :prepend-inner-icon="icons.search"
                outlined desne v-model="string"
                @input="searchCodes()"
                @change="$emit('code',search)"
                :append-outer-icon="icons.close"
                @click:append-outer="closeSearch()"
        />
        <v-list dense>
            <v-list-item v-for="r in results" @click="setCode(r.code)" >
                <v-list-item-title>{{r.code}}</v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "InvoiceCodeSearch",
    components: {},
    data() {
      return {
        search: false,
        string: undefined,
        results: undefined,
        code: undefined
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    methods: {
      ...mapActions(['get', 'post']),
      async searchCodes(){
        let data = {
          string: this.string
        }
        this.results = await this.post({path:'api/invoicing/searchcodes', body: data })
      },
      closeSearch(){
        this.string=undefined;
        this.results=undefined;
        this.search=false;
      },
      setCode(c){
        console.log(c)
        this.code=c;
        this.results=undefined;
        this.search=false;
        this.$emit('code',c)
      }
    }
  }

</script>

<style scoped>

</style>